import React from 'react'

export const TestsAndGamesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="2"
      y="5"
      width="12"
      height="7"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M5 7.2v2.6M4 8.5h2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <circle
      cx="10.5"
      cy="7.5"
      r="1"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <circle
      cx="10.5"
      cy="9.5"
      r="1"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
)
